export const KYBER_SYNC_TOKENS = 'KYBER_SYNC_TOKENS';
export const KYBER_SYNC_USER_CURRENCIES = 'KYBER_SYNC_USER_CURRENCIES';
export const ONEINCH_SYNC_TOKENS = 'ONEINCH_SYNC_TOKENS';

export default {
  KYBER_SYNC_TOKENS,
  KYBER_SYNC_USER_CURRENCIES,
  ONEINCH_SYNC_TOKENS,
};
